import { render, staticRenderFns } from "./TransitionData.vue?vue&type=template&id=1d876f8d&scoped=true"
import script from "./TransitionData.vue?vue&type=script&lang=js"
export * from "./TransitionData.vue?vue&type=script&lang=js"
import style0 from "./TransitionData.vue?vue&type=style&index=0&id=1d876f8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d876f8d",
  null
  
)

export default component.exports